import { AppRouter } from '@core/router/AppRouter';

const App = () => <AppRouter />;

export default App;
